<script>
module.exports = {
    data() {
        return {
            mapPopupAttached: false,
            mapTouchedByUser: false,
            mapLimits: {
                zoomIn: false,
                zoomOut: false
            },
        }
    },

    methods: {
        dispatchEvent(event, details, waitFor = undefined)
        {
            details = {
                ...details,
                id: this.$refs.map.id,
            }

            if(waitFor == undefined || this[waitFor] == true)
            {
                console.log('Helpers.dispatchEvent', event, details)
                window.dispatchEvent(
                    new CustomEvent(event, {detail: details})
                )
            }
            else
            {
                console.log('Helpers.dispatchEvent - waiting...', event, details, waitFor)
                setTimeout(() => {
                    this.dispatchEvent(event, details, waitFor)
                }, 500)
            }
        },

        checkMapScope(event)
        {
            return (event.detail.container == this.$refs.map.id)
        },

        mapUserIsInteracting(event)
        {
            if(this.checkMapScope(event))
            {
                console.log('mapUserIsInteracting', event)
                this.mapTouchedByUser = true
            }
        },

        mapUserIsInteractingTrusted(event)
        {
            if(this.checkMapScope(event))
            {
                console.log('mapUserIsInteractingTrusted', event)

                if(event.detail.trusted)
                {
                    this.mapTouchedByUser = true
                }
            }
        },

        zoomIn()
        {
            this.dispatchEvent('tecnomap.navigationControl.zoom.in', {})
        },

        zoomOut()
        {
            this.dispatchEvent('tecnomap.navigationControl.zoom.out', {})
        },

        popupOpened(event)
        {
            if(this.checkMapScope(event))
            {
                console.log('popupOpened', event)

                this.mapPopupAttached = true
            }
        },

        popupClosed(event)
        {
            if(this.checkMapScope(event))
            {
                console.log('popupClosed', event)

                this.mapPopupAttached = false
            }
        },

        mapZoomExceeded(event)
        {
            if(this.checkMapScope(event))
            {
                console.log('mapZoomExceeded', event)

                this.mapLimits.zoomIn = event.detail.zoomIn
                this.mapLimits.zoomOut = event.detail.zoomOut
            }
        }
    },

    mounted() {
        window.addEventListener('tecnomap.click', this.mapUserIsInteracting)
        window.addEventListener('tecnomap.dragstart', this.mapUserIsInteracting)
        window.addEventListener('tecnomap.zoomstart', this.mapUserIsInteractingTrusted)
        window.addEventListener('tecnomap.navigationControl.zoomIn', this.mapUserIsInteracting)
        window.addEventListener('tecnomap.navigationControl.zoomOut', this.mapUserIsInteracting)
        window.addEventListener('tecnomap.drawer.attachMarkerPopup', this.popupOpened)
        window.addEventListener('tecnomap.drawer.detachMarkerPopup', this.popupClosed)
        window.addEventListener('tecnomap.navigationControl.zoom.exceeded', this.mapZoomExceeded)
    },

    beforeDestroy() {
        window.removeEventListener('tecnomap.click', this.mapUserIsInteracting)
        window.removeEventListener('tecnomap.dragstart', this.mapUserIsInteracting)
        window.removeEventListener('tecnomap.zoomstart', this.mapUserIsInteractingTrusted)
        window.removeEventListener('tecnomap.navigationControl.zoomIn', this.mapUserIsInteracting)
        window.removeEventListener('tecnomap.navigationControl.zoomOut', this.mapUserIsInteracting)
        window.removeEventListener('tecnomap.drawer.attachMarkerPopup', this.popupOpened)
        window.removeEventListener('tecnomap.drawer.detachMarkerPopup', this.popupClosed)
        window.removeEventListener('tecnomap.navigationControl.zoom.exceeded', this.mapZoomExceeded)
    }
}
</script>